(function () {
  'use strict';

  // ---------- FAQ 手风琴 ----------
  document.querySelectorAll('[data-aa-faq]').forEach(function (list) {
    var items = list.querySelectorAll('.aa-faq-item');
    items.forEach(function (item, index) {
      var btn = item.querySelector('[data-aa-faq-btn]');
      if (!btn) return;
      // 默认展开第一条,和原页面一致
      if (index === 0) item.classList.add('aa-open');
      btn.addEventListener('click', function () {
        item.classList.toggle('aa-open');
      });
    });
  });

  // ---------- 新版评价卡片切换 ----------
  document.querySelectorAll('[data-aa-testi2]').forEach(function (wrapper) {
    var cards = wrapper.querySelectorAll('.aa-testi2-card');
    var prevBtn = wrapper.querySelector('[data-aa-testi2-prev]');
    var nextBtn = wrapper.querySelector('[data-aa-testi2-next]');
    if (cards.length === 0) return;

    var index = 0;
    var total = cards.length;

    function show(idx) {
      cards.forEach(function (c, i) {
        if (i === idx) { c.classList.add('aa-testi2-card--active'); }
        else { c.classList.remove('aa-testi2-card--active'); }
      });
    }

    function go(delta) {
      index = (index + delta + total) % total;
      show(index);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { go(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(1); });

    // 自动轮播 5s
    var autoplay = setInterval(function () { go(1); }, 5000);
    wrapper.addEventListener('mouseenter', function () { clearInterval(autoplay); });

    show(0);
  });
})();
